import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PageModeEnum } from 'app/teacher/activities/custom/page-mode.enum';
import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

@Injectable({
  providedIn: 'root'
})
export class SharedLinksGuard  {
  private readonly pageModeParamName = 'pageMode';

  public constructor(private readonly router: Router) { }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const pageMode: PageModeEnum = this.getPageModeParamValue(route);

    return this.router.createUrlTree(this.getUrlRoutes(route, pageMode));
  }

  private getUrlRoutes(route: ActivatedRouteSnapshot, pageMode: PageModeEnum): string[] {
    const classId: string = this.getRouteParamValue(route, 'classId');
    const sharedFolderId = this.getRouteParamValue(route, 'sharedFolderId');
    const folderId = this.getRouteParamValue(route, 'folderId');

    switch (pageMode) {
      case PageModeEnum.Missions:
        return TEACHER_ROUTE.MISSIONS.SHARED.route(classId, sharedFolderId, folderId);
      case PageModeEnum.Gameshows:
        return TEACHER_ROUTE.GAMESHOWS.SHARED.route(classId, sharedFolderId, folderId);
      default:
        return TEACHER_ROUTE.ACTIVITIES.SHARED.route(classId, sharedFolderId, folderId);
    }
  }

  private getPageModeParamValue(route: ActivatedRouteSnapshot): PageModeEnum {
    return route.paramMap.get(this.pageModeParamName)?.toUpperCase() as PageModeEnum ?? PageModeEnum.Default;
  }

  private getRouteParamValue(route: ActivatedRouteSnapshot, paramName: string): string {
    return route.paramMap.get(paramName) ?? '';
  }
}
